module.exports = "/images/img-3.jpg?bd5bf49ac098d15e14f7e35211100f8c";